import React from "react";
import { withRouter } from "../_shared/withRouter";
import RegisterComponent from "../template/_common/registerComponent";

const UserRegister = () => {
  return <RegisterComponent roleType={"user"} role={"3"} />;
};

export default withRouter(UserRegister);
